module.exports = __webpack_public_path__ + "b621e84f2e2380ad2647f047b4f30ff9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/owls/error-owl-frozen.png
// module id = 1150
// module chunks = 0